import { cx } from '../utils/cx.js';
import styles from './Skeleton.module.css';

export type SkeletonProps = { className?: string; variant?: 'text' | 'title' | 'avatar' };

export function Skeleton({ className, variant = 'text' }: SkeletonProps) {
  return <div className={cx(styles.skel, variant === 'text' && styles.text, variant === 'title' && styles.title, variant === 'avatar' && styles.avatar, className)} aria-hidden />;
}
